// @todo: future webpack versions can also deal with non js entries correctly
import './style.scss';

// A list of component JS files that we require for every page:
import './components/navigation/_navigation';
import './components/panorama/_panorama';
